import lottie from "lottie-web";

const ICON_ANIMATION_SELECTOR = ".block-icon-animation[data-src]";
const ROOT_MARGIN = "120px 0px";

function loadIconAnimation(el) {
	if (el.dataset.loaded === "true") {
		return;
	}

	const animationSrc = el.dataset.src;
	if (!animationSrc) {
		return;
	}

	lottie.loadAnimation({
		container: el,
		renderer: "svg",
		loop: true,
		autoplay: true,
		path: animationSrc,
	});
	el.dataset.loaded = "true";
}

export default function initBlockIconAnimations() {
	const animations = Array.from(document.querySelectorAll(ICON_ANIMATION_SELECTOR));
	if (!animations.length) {
		return;
	}

	if (!("IntersectionObserver" in window)) {
		animations.forEach(loadIconAnimation);
		return;
	}

	const observer = new IntersectionObserver(
		(entries, currentObserver) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}
				loadIconAnimation(entry.target);
				currentObserver.unobserve(entry.target);
			});
		},
		{ rootMargin: ROOT_MARGIN }
	);

	animations.forEach((el) => observer.observe(el));
}
